import { VALIDATION_TYPE } from '../data-types/validation/validationEnums';

// tslint:disable-next-line:no-any
export const isOfType = (data: any, type: VALIDATION_TYPE) => typeof data === type;
